


<template>
<div class="cntnt">
    <div id="customerCare" class="section-content customer-care-section">
  
  <!-- Centralized Care Banner -->


<div class="flyer" style="display: flex; align-items: flex-start;">
  <img src="../assets/call-center.png" alt="Call Center" style="width: 50px; height: 65px; margin-right: 4px;">

  <div style="line-height: 1.1; font-size: 16.5px;">
    <div>
      Centralized Customer Care Number:
      <strong style="color: #FFD700;font-size: 18px;">1912</strong>
    </div>
    <div>
      কেন্দ্ৰীয় গ্ৰাহক সেৱা নম্বৰ:
      <strong style="color: #FFD700;">১৯১২</strong>
    </div>
  </div>
</div>



  <b-row>
    <b-col cols="12">
      <h1 class="heading">এপিডিচিএল গ্ৰাহক সেৱা</h1>
    </b-col>
  </b-row>

 <div class="content" style="text-align:left; font-size:1rem; color:#333;">

        <strong>যিকোনো অভিযোগ বা প্ৰশ্নৰ বাবে :</strong><br><br>

<!-- Contact / Complaint Number -->
        <div class="contact-item">
          <img
            src="../assets/call-center.png"
            class="contact-icon-img"
            alt="Call Center"
          />

          <div class="contact-text">
            <strong>যোগাযোগ / অভিযোগ নম্বৰ :</strong>

            <div>
              <span style="color:#d32f2f; font-weight:bold;">
                ১৯১২
              </span>
              <span style="font-size:14px;">
                (অসমৰ পৰা কৰা ফোন কলৰ বাবে)
              </span>
            </div>

            <div>
              <span style="color:#d32f2f; font-weight:bold;">
               ০৩৬১-৩১২৬২০১ / ০৩৬১-২৮০৩২০০
              </span>
              <span style="font-size:14px;">
             (অসমৰ বাহিৰৰ পৰা কৰা ফোন কলৰ বাবে)
              </span>
            </div>
          </div>
        </div>

        <!-- WhatsApp -->
        <div class="contact-item">
          <img
            src="../assets/whatsapp.png"
            class="contact-icon-img"
            alt="WhatsApp"
          />

          <div class="contact-text">
            <strong>হোৱাটচএপ নম্বৰ :</strong>

            <span
              class="contactTextStyle"
              style="color:#388e3c; font-weight:bold;"
            >
               ৭৫৭৫৯৯৯৬৬৬
            </span>
          </div>
        </div>

        <!-- E-mail -->
        <div class="contact-item">
          <b-icon
            icon="envelope-fill"
            class="contact-icon"
          />

          <div class="contact-text">
            <strong> ই-মেইল :</strong>

            <span
              class="contactTextStyle"
              style="color:#388e3c; font-weight:bold;"
            >
              support@apdcl.org
            </span>
          </div>
        </div>

        <!-- VMN -->
        <div class="contact-item">
          <b-icon
            icon="chat-fill"
            class="contact-icon"
          />

          <div class="contact-text">
            <strong> ভাৰ্চুৱেল মোবাইল নম্বৰ (VMN):</strong>

            <span
              class="contactTextStyle"
              style="color:#388e3c; font-weight:bold;"
            >
               ৮৪২৪৮৮২৪৮৮
            </span>

            <small class="contact-note">
              (পোষ্টপেইড বিল সম্পৰ্কে জানিবলৈ:
              <span class="contact-note-key">
                BILL &lt; space &gt; ১২ অংকৰ গ্ৰাহক নম্বৰ
              </span>
             টাইপ কৰি ওপৰৰ
              <strong>VMN **৮৪২৪৮৮২৪৮৮**</strong>.
                লৈ এছ এম এছ কৰক।)
            </small>
          </div>
        </div>

  
        <div class="contact-item">
          <span class="contact-icon billing-arrow">▶</span>

          <div class="contact-text">
            <small class="contact-note billing-note">
               বিলিং সম্পৰ্কীয় অভিযোগৰ বাবে অনুগ্ৰহ কৰি আপোনাৰ

          <span class="contact-note-key">
            ১২ অংকৰ গ্ৰাহক নম্বৰ আৰু উপ-সংমণ্ডলৰ নাম
              </span>   দিয়ক।
            </small>
          </div>
        </div>
      </div>
    </div>

<br> <br>
<div id="kofficial" class="section-content" style="display: none; overflow-y: auto; max-height: 70vh;">
      <b-row><b-col cols="12"><h1 class="heading">মূখ্য বিষয়াসকলৰ(মুখ্য কাৰ্যালয়) যোগাযোগ</h1></b-col></b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getKeyOfficial" :fields="KeOfficialfields" />
      </p>
    </div>

<div id="zone" class="section-content" style="display: none; overflow-y: auto; max-height: 70vh;">
      <b-row><b-col cols="12"><h1 class="heading">ক্ষেত্ৰ কাৰ্যালয়:<span class="zone-text">মণ্ডলসমূহৰ যোগাযোগ</span></h1></b-col></b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getZoneData" :fields="Zonefields" />
      </p>
    </div>

    <div id="circle" class="section-content" style="display: none; overflow-y: auto; max-height: 70vh;">
      <b-row><b-col cols="12"><h1 class="heading">ক্ষেত্ৰ কাৰ্যালয়:<span class="zone-text"> চক্ৰসমূহৰ যোগাযোগ</span></h1></b-col></b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getCircleContact" :fields="Circlefields">
          <template v-slot:cell(email)="data">
            <span v-html="data.value"></span>
           </template>
        </b-table>
      </p>
    </div>

<div id="division" class="section-content" style="display: none; overflow-y: auto; max-height: 70vh;">
      <b-row><b-col cols="12"><h1 class="heading">ক্ষেত্ৰ কাৰ্যালয়:<span class="zone-text"> সংমণ্ডলসমূহৰ যোগাযোগ</span></h1></b-col></b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getDivisionContact" :fields="Divisionfields" />
      </p>
    </div>

    <div id="subdivision" class="section-content" style="display: none; overflow-y: auto; max-height: 70vh;">
      <b-row><b-col cols="12"><h1 class="heading">ক্ষেত্ৰ কাৰ্যালয়:<span class="zone-text"> উপ-সংমণ্ডলসমূহৰ যোগাযোগ</span></h1></b-col></b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getSubDivContact" :fields="SubDivisionfields" />
      </p>
    </div>

    <div id="irca" class="section-content" style="display: none; overflow-y: auto; max-height: 70vh;">
      <b-row>
  <b-col cols="12">
    <h1 class="heading">
      ক্ষেত্ৰ কাৰ্যালয়: <span class="zone-text">আই.আৰ.চি.এ. সমূহৰ যোগাযোগ</span> 
      <span class="sub-heading">(ঔদ্যোগিক ৰাজহ সংগ্ৰহ এলেকা)</span>
    </h1>
  </b-col>
</b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getIRCAContact" :fields="Ircafields" />
      </p>
    </div>

    <div id="tc" class="section-content" style="display: none; overflow-y: auto; max-height: 70vh;">
      <b-row><b-col cols="12"><h1 class="heading">ক্ষেত্ৰ কাৰ্যালয়:<span class="zone-text">টি এণ্ড চি সংমণ্ডলসমূহৰ যোগাযোগ</span></h1></b-col></b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getTCContact" :fields="TCfields" />
      </p>
    </div>

    <div id="agm" class="section-content" style="display: none; overflow-y: auto; max-height: 70vh;">
      <b-row><b-col cols="12"><h1 class="heading">জিলাভিত্তিক এজিএম(প্ৰকল্প) সমূহৰ যোগাযোগ</h1></b-col></b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getAgmContact" :fields="Agmfields" />
      </p>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'
// import * as pdfMake from 'pdfmake/build/pdfmake';
// import * as pdfFonts from 'pdfmake/build/vfs_fonts';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

var thColor = '#0288d1';

export default {

  data() {
      return {
        show:false,
        KeOfficialfields: [
          { key: 'contact_person', label: 'Name',thStyle: {width: '25vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'designation', label: 'Designation',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'phone', label: 'Phone',thStyle: {width: '25vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'email', label: 'Email',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
        ],
        Zonefields: [
          { key: 'zone_name', label: 'Zone',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'contact_person', label: 'Contact Person',thStyle: {width: '25vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'designation', label: 'Designation',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'email', label: 'Email',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
          ],
        Circlefields: [
          { key: 'zone_name', label: 'Zone',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'circle_name', label: 'Circle',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'contact_person', label: 'Contact Person',thStyle: {width: '25vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'phone', label: 'Phone',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'email', label: 'Email',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
        ],
        Divisionfields: [
          { key: 'circle_name', label: 'Circle',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'division_name', label: 'Division',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'contact_person', label: 'Contact Person',thStyle: {width: '30vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'phone', label: 'Phone',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'email', label: 'Email',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
        ],
        SubDivisionfields: [
          { key: 'circle_name', label: 'Circle',thStyle: {width: '8vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'division_name', label: 'Division',thStyle: {width: '8vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'sd_name', label: 'Sub-Division',thStyle: {width: '8vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'contact_person', label: 'Contact Person',thStyle: {width: '30vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'email', label: 'Email',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
        ],
        Ircafields: [
          { key: 'irca_name', label: 'Name',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'contact_person', label: 'Contact Person',thStyle: {width: '30vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'email', label: 'Email',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
      ],
      TCfields: [
        { key: 'tc_name', label: 'Name',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'contact_person', label: 'Contact Person',thStyle: {width: '30vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'email', label: 'Email',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
      ],
      Agmfields: [
          { key: 'district', label: 'District',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'contact_person', label: 'Contact Person',thStyle: {width: '30vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'email', label: 'Email',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
      ]
      }
  },
  computed:
  {
    ...mapGetters([
      'getKeyOfficial',
      'getZoneData',
      'getCircleContact',
      'getDivisionContact',
      'getSubDivContact',
      'getIRCAContact',
      'getTCContact',
      'getAgmContact'
    ])

  },
  methods: {
    ...mapActions([
      'retrieveAllContact'
    ]),

//     generate(filename) {
//       var header = ['Sl No','Contact Person','Designation','Phone','Mobile','Email']
//       var temp = []

//       temp.push(header)
//       var i = 1;
//       this.getKeyOfficial.forEach(element => {
//         var temp1 = [i++, element.contact_person, element.designation, element.phone, element.mobile, element.email]
//         temp.push(temp1)
//       })


// var currentDate = new Date()

// var dd = currentDate.getDate();
//     var mm = currentDate.getMonth() + 1;

//     var yyyy = currentDate.getFullYear();
//     if (dd < 10) {
//         dd = '0' + dd;
//     }
//     if (mm < 10) {
//         mm = '0' + mm;
//     }
//     var today = dd + '/' + mm + '/' + yyyy;

//       var docDefinition = {
//         pageSize: 'A4',
//         pageOrientation: 'landscape',
//         content: [
//           { text: 'Assam Power Distribution Company Limited', style: 'header' },
//           { text: 'Key Official Contact', style: 'subheader' },

//           {
//             style: 'tableExample',
//             layout: {
//                     fillColor: function (rowIndex, node, columnIndex) {
//                         return (rowIndex === 0) ? '#80deea ' : null;
//                     },

//                 },

//   				   table: {
//                headerRows: 1,
//   				        body: temp
//                      }
//           },
//           { text: 'Generated Date: ' + today  + ' ' + currentDate.toLocaleTimeString() , style: 'normalText'},
//              ],
//              styles: {
//                   header: {
//                   fontSize: 20,
//                   bold: true,
//                   alignment: 'center',
//                   margin: [0, 0, 0, 5]
//               },
//             subheader: {
//                 fontSize: 15,
//                 alignment: 'center',
//                 bold: true,
//                 margin: [0, 10, 0, 5]
//             },
//             normalText: {
//                 fontSize: 8,
//                 alignment: 'center',
//                 margin: [0, 10, 0, 5]
//             },
//             tableExample: {
//                 margin: [0, 5, 5, 0],
//                 alignment: 'left',
//                 fontSize: 10,
//             }
//         },

//       };

//       pdfMake.createPdf(docDefinition).download(filename + ".pdf");
//     }
  },
  beforeMount() {
  
      if(this.getKeyOfficial.length == 0) {
        this.retrieveAllContact();
     
      }
  }
}
</script>
<style scoped="true">
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;
}
.zone-text {
  color: #e3ac5a; 
}
.content{
  text-align: justify;
  line-height: 1.8rem;
  font-size: 0.9rem;
}
.cntnt {
  box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
  padding: 10px 30px 10px 30px;
  overflow-y: auto;
  max-height: calc(100vh - 120px); /* Adjust 120px as needed based on your header */
  -webkit-overflow-scrolling: touch; /* for smooth scroll on iOS */
}
.customer-care-section {
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 70vh;
  position: relative;
  background-color: #f9f9f9;
  border-radius: 10px;
  padding: 1rem;
}


.flyer{
  font-family: Arial, sans-serif;
  max-width: 350px;
  background: #007BFF;
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  float: right;
  margin: 1rem;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.contact-icon {

  font-size: 1rem !important;

  width: 22px;

  height: 22px;

  color: #d84315;

  margin-right: 8px;

  margin-top: 2px;

  flex-shrink: 0;

}

.contact-icon-img {

  width: 22px !important;

  height: 22px !important;

  margin-right: 8px;

  margin-top: 2px;

  object-fit: contain;

  flex-shrink: 0;

}

.contact-item {
  display: flex;
  align-items: flex-start;
  margin: 6px 0;
  width: 100%;
}

.contact-text {
  flex: 1;
  min-width: 0;
}

.contact-icon {
  font-size: 1rem !important;
  width: 22px;
  height: 22px;
  color: #d84315;
  margin-right: 8px;
  margin-top: 2px;
  flex-shrink: 0;
}

.contact-icon-img {
  width: 22px !important;
  height: 22px !important;
  margin-right: 8px;
  margin-top: 2px;
  object-fit: contain;
  flex-shrink: 0;
}

.contact-note {
  font-size: 0.9rem;
  font-style: italic;
  font-weight: normal;
  color: #555;
  margin-left: 8px;
  line-height: 1.5;
}

.contact-note-key {
  color: #0d47a1;
  font-weight: bold;
}

.billing-note {
  margin-left: 0;
}

.billing-arrow {
  font-size: 1rem !important;
  width: 22px;
  height: 22px;
  line-height: 22px;
  margin-right: 8px;
  flex-shrink: 0;
}

table{
  text-align: left !important;
}
.contactTextStyle{
    text-shadow: 1.5px 0px 1px grey;
    font-size:1.2rem;
    font-weight:700;
    color:#03a9f4;
    letter-spacing:2px;
  }

@media (max-width: 768px) {
  .cntnt{
    box-shadow: none;
    padding:10px 30px 10px 30px;
  }
  .flyer {
    float: none;
    margin: 1rem auto;
  }
   #kofficial{
    max-height:50vh !important;
   }
   #zone{
    max-height:50vh !important;
   }
   #circle{
    max-height:50vh !important;
   }
   #division{
    max-height:50vh !important;
   }
   #subdivision{
    max-height:50vh !important;
   }
   #irca{
    max-height:50vh !important;
   }
   #tc{
    max-height:50vh !important;
   }
   #agm{
    max-height:50vh !important;
   }
  }
@media (max-width: 576px) {
  .flyer{
    width: 100%;
    max-width: 90%;
    margin: 1rem auto;
    font-size: 0.95rem;
  }
  .flyer strong {
    font-size: 1.3rem !important;
  }
  #kofficial{
    max-height:50vh !important;
   }
  #zone{
    max-height:50vh !important;
  }
  #circle{
   max-height:50vh !important;
  }
  #division{
   max-height:50vh !important;
  }
  #subdivision{
    max-height:50vh !important;
  }
  #irca{
    max-height:50vh !important;
  }
  #tc{
    max-height:50vh !important;
  }
  #agm{
    max-height:50vh !important;
  }
}
  
</style>
